<template>
    <b-container>
        
        <div id="printme">
        <img style="width:140px;float:left;margin-top:40px;" src="@/assets/images/logo.jpg">
        <b-row>
            <b-col>
                <h5 style="margin-top:40px;" align="center"><b>{{form.BoardName}}</b></h5>
                <P style="margin-bottom:100px;" align="center">{{form.BoardAddress}}</P>
            </b-col>
        </b-row>
        <hr>
        
        
        <h6 class="mb-5" align="center"><b><u>REGISTRATION DETAILS</u></b></h6>
            <b-row>
                <b-col sm="9">
                    <b-row>
                        <b-col sm="3">Registration Number:</b-col>
                        <b-col sm="4">{{form.AlltomentPreFixMarathi}}{{form.AllotmentYear}}/{{form.AllotmentNo}}</b-col>
                    
                
                        <b-col sm="5">{{form.FullName}}</b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="3"></b-col>
                        <b-col sm="4"></b-col>
                        
                    </b-row>
                    <b-row>
                        <b-col sm="3">Date of Registration:</b-col>
                        <b-col sm="4">{{form.PaymentDate}}</b-col>
                    </b-row>
                    
                </b-col>
                <b-col sm="3">
                       <img style="width:140px" :src="getImgUrl(form.PhotoPath)"><br/>
                       
                </b-col>
            </b-row>
                <br/>
            
            
            
    </div>
        
        
    </b-container>
</template>

<script>
import apis from "@/apis";
import vueHtmlToPaper from "vue-html-to-paper";
export default {
  props: ["appid"],
  data() {
    return {
      form: {
        ApplicationID: "",
        ApplicationNo: "",
        UserID: "",
        FullName: "",
        Category: "",
        RegType: "",
        DOB: "",
        RetirementDate: "",
        Nominee1: "",
        Relation1: "",
        Nominee2: "",
        Relation2: "",
        CorrespondanceAddress: "",
        PermanentAddress: "",
        Branch: "",
        CompanyName: "",
        UserBFormID: "",
        AllotmentNo: "",
        BoardID: "",
        AllotmentPrefix: "",
        AlltomentPreFixMarathi: "",
        AllotmentYear: "",
        IsFeesPaid: "",
        EventTitle: "",
        BoardName: "",
        BoardAddress: "",
        UserID:""
      },
      isLoading: false,
      alertText: "",
      showDismissibleAlert: false,
      variant: "success"
    };
  },

  methods: {
    print() {
      this.$htmlToPaper("printme");
    },
    getImgUrl(pic) {

      if (pic) {
        if (pic.split(".").pop() == "pdf") {
          return require("@/assets/Pdf.jpg");
        }
        return (
          "https://s3.ap-south-1.amazonaws.com/sgbimages/" +
          this.form.UserID +
          "/" +
          pic
        );
      }
    }
  },
  mounted() {

    let promise = apis.ReadBFormSummary(this.appid);

    promise
      .then(response => {

        if (response.status == 200) {
          this.form = response.body[0];
          this.isLoading = false;
        } else {
          this.alertText = response.body;

          this.variant = "warning";
          this.showDismissibleAlert = true;
        }
      })
      .catch(err => {
        this.alertText = err.body;
        this.showDismissibleAlert = true;
        this.variant = "danger";
      });
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SummaryBform.vue